import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const award = {
  createAward: lazyModuleMethod(() => import('./createAward'), 'default'),
  fetchAward: lazyModuleMethod(() => import('./fetchAward'), 'default'),
  fetchAwards: lazyModuleMethod(() => import('./fetchAwards'), 'default'),
  updateAward: lazyModuleMethod(() => import('./updateAward'), 'default'),
}
